import React from "react";
import { GatsbyImage as Image, getImage } from "gatsby-plugin-image";
import EllipseIcon from "./EllipseIcon";
import { graphql } from "gatsby";

export default function EmployeeCard({ data }) {
  return (
    <div className="text-center m-auto py-4">
      <div
        role="button"
        tabIndex="0"
        className="employee-img-wrapper cursor-default"
      >
        <div className="employee-img hover:opacity-0">
          <Image
            ariaRole="image"
            image={getImage(data.defaultImage)}
            alt={data.defaultImage.alt}
            className="rounded-full border-thermaGrey border-4 img-wrap"
            style={{
              maxWidth: "350px",
            }}
          />
          <div className="flex w-full justify-center items-center">
            <EllipseIcon hovered={false} />
          </div>
        </div>
        <div className="employee-img">
          <Image
            ariaRole="image"
            image={getImage(data.hoverImage)}
            alt={data.hoverImage.alt}
            className="rounded-full border-thermaBlue border-4 img-wrap"
            style={{
              maxWidth: "350px",
            }}
          />
          <div className="flex w-full justify-center items-center">
            <EllipseIcon hovered={true} />
          </div>
        </div>
      </div>
      <div className="flex flex-col">
        <p className="font-a3 text-2xl text-thermaGrey-lighter">
          {data.employeeName}
        </p>
        <p className="font-a3 text- text-thermaGrey-darker w-56 mx-auto ">
          {data.jobTitle}
        </p>
      </div>
    </div>
  );
}

export const query = graphql`
  fragment EmployeeCardComponent on DatoCmsEmployeeCard {
    internal {
      type
    }
    employeeName
    jobTitle
    defaultImage {
      alt
      gatsbyImageData
    }
    hoverImage {
      gatsbyImageData
      alt
    }
  }
`;
